module.exports = __webpack_public_path__ + "img/newebpay.0113e0d3.png";